// extracted by mini-css-extract-plugin
export var footer = "_nn-0";
export var inherit = "_nn-1";
export var input = "_nn-2";
export var modalContent = "_nn-3";
export var quillEditor = "_nn-4";
export var subtitle = "_nn-5";